import { trackUserEvent } from '@vend/utilities'
import { PAYMENT_TYPES } from '@vend/business-components'
import { WEB_REGISTER } from '../../../web-register.constant'
import { LSPAY_STEPS } from './lspayConstants'

interface Args {
  step: LSPAY_STEPS
  transactionId: string
  paymentTypeId: number
  isRefund: boolean
  isSandbox?: boolean
  isServerDriven: boolean
}

export type TimerStopper = () => void

// return a closure that can send an UBE event with timing data when it is called
export const startTimer = ({
  step,
  transactionId,
  paymentTypeId,
  isRefund,
  isSandbox,
  isServerDriven,
}: Args): TimerStopper => {
  if (!ENABLED_PAYMENT_TYPES.includes(paymentTypeId)) {
    return () => {}
  }

  const startTime = Date.now()
  return () => {
    const endTime = Date.now()
    const eventName =
      (isSandbox ? 'Sandbox ' : '') +
      (isRefund
        ? `Refunded transaction for payment type ${paymentTypeId}: ${step} ended`
        : `Transaction for payment type ${paymentTypeId}: ${step} ended`)

    trackUserEvent(WEB_REGISTER.DISPLAY_NAME, eventName, {
      transactionId,
      paymentTypeId,
      step,
      startTime: new Date(startTime).toUTCString(),
      endTime: new Date(endTime).toUTCString(),
      duration: endTime - startTime,
      isServerDriven,
    })
  }
}

const ENABLED_PAYMENT_TYPES = [PAYMENT_TYPES.LSPAY]
